<script lang="ts">
	//UI
	import { PhotoIcon2, SelfOrderCheck } from "@hitit/new_ui";
	//Utils
	import { api, t } from "@hitit/hub/src/stores";
	import { OBJECT_PURPOSE_STORE_REGISTRATION, putS3File } from "@hitit/api";
	import { formatNumber } from "@hitit/utils";
	//Types
	import type { CategoryData, StoreItemData } from "@hitit/api/src/types";
	import ComponentLoading from "@hitit/hub/src/v7/components/common/ComponentLoading.svelte";
	import DragAndDrop from "@hitit/hub/src/components/DragAndDrop.svelte";
	//Props
	export let item: StoreItemData;
	//Constants
	//Variables
	let loading = false;
	let checked = false;
	let url = "";
	let imageViewType = true;
	let mouseenter = false;
	//Functions
	async function uploadImage(e: { detail: File }) {
		//
		// try {
		// 	loading = true;
		// 	const fileUploadResponse = await $api.getFileUploadUrl({
		// 		fileName: "registration",
		// 		fileType: "PNG",
		// 		objectPurpose: OBJECT_PURPOSE_STORE_REGISTRATION,
		// 	});
		// 	await putS3File(fileUploadResponse.data.url, e.detail);
		// 	imageaddr = fileUploadResponse.data.id;
		// 	changeImage(e.detail);
		// 	loading = false;
		// } catch (error) {
		// 	console.log(error);
		// }
	}
	async function imageFileView() {}

	//Do
	$: registrationStyle = url ? `background-image : url(${url})` : "";
</script>

<div class="container">
	<div class="img-box">
		{#if url}
			<img src={url} alt="item" />
		{:else}
			<div
				class="registration"
				style={registrationStyle}
				on:click={imageFileView}
			>
				<div
					class="drop-cover"
					on:dragover={() => {
						mouseenter = true;
					}}
					on:dragleave={() => {
						mouseenter = false;
					}}
					on:mouseleave={() => {
						mouseenter = false;
					}}
					on:mouseenter={() => {
						mouseenter = true;
					}}
				>
					{#if loading}
						<ComponentLoading />
					{:else}
						<DragAndDrop on:file-update={uploadImage}>
							<div class="photoicon">
								<PhotoIcon2 active={mouseenter} />
							</div>
						</DragAndDrop>
					{/if}
				</div>
			</div>
		{/if}
		<img alt="item" />
	</div>
	<div class="item-info">
		<div class="check" on:click={() => (checked = !checked)}>
			<SelfOrderCheck active={checked} />
		</div>
		<span class="item-name">{item.translationDTOs[0].name}</span>
		<span class="item-price">{formatNumber(item.price)}원</span>
		<div class="btn-wrapper image">
			<button
				class="button"
				class:active={imageViewType}
				on:click={() => (imageViewType = !imageViewType)}
			>
				{$t("mbr.self_order.image_view")}
			</button>
			<button
				class="button list"
				class:active={!imageViewType}
				on:click={() => (imageViewType = !imageViewType)}
			>
				{$t("mbr.self_order.list_view")}
			</button>
		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../../variables.scss";
	.container {
		width: 300px;
		height: 460px;
		border-radius: 5px;
		border: 1px solid #6591fa;
		.img-box {
			width: 300px;
			height: 300px;

			.registration {
				background-size: contain;
				background-repeat: no-repeat;
				background-position: center center;
				width: 100%;
				height: 100%;
				position: relative;
				background-color: #e6e7ed;
				border-top-left-radius: 5px;
				border-top-right-radius: 5px;

				.drop-cover {
					background-color: rgba($color: #e6e7ed, $alpha: 0.8);
					width: 100%;
					height: 100%;
					border-radius: 5px;

					&:hover {
						cursor: pointer;
					}
					.photoicon {
						position: absolute;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);
						width: 60.5px;
						height: 61px;
					}
				}
			}
		}

		img {
			width: 300px;
			height: 300px;
		}

		.item-info {
			position: relative;
			display: flex;
			flex-direction: column;
			gap: 10px;
			height: 120px;
			background-color: #f0f0f4;
			padding: 20px;
			border-bottom-left-radius: 5px;
			border-bottom-right-radius: 5px;

			.check {
				position: absolute;
				top: 10px;
				right: 10px;
				cursor: pointer;
			}

			.item-name {
				font-size: 20px;
				font-weight: 400;
				color: #46474b;
			}
			.item-price {
				font-size: 20px;
				color: #46474b;
			}
			.btn-wrapper {
				display: flex;
				gap: 10px;
			}
			button {
				width: auto;
				height: 40px;
				padding: 0px 20px 0px 20px;
				background-color: inherit;
				border: 1px solid #bcbfc3;
				border-radius: 20px;
				color: #46474b;
				@include appleAdjustTextForSize(16, true);

				&.active {
					color: white;
					border: none;
					background-color: #6d6f76;
				}
				&:hover {
					cursor: pointer;
				}
			}
		}
	}
</style>
